import React, { useState } from "react";
import { Quote } from "lucide-react";
import { testimonialTabs } from "../mock";

import { tr } from "../i18n";
export default function Testimonials() {
  const [active, setActive] = useState(testimonialTabs[0].id);
  const current = testimonialTabs.find((t) => t.id === active);

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12 reveal">
          <div className="deco-line w-24 mx-auto mb-6" />
          <h2 className="font-display text-[34px] md:text-[46px] text-[#0b1f3a]">
            {tr("What our clients say about us")}
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {testimonialTabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setActive(t.id)}
              className={`px-5 py-2.5 rounded-full text-[14px] font-medium transition-colors ${
                active === t.id
                  ? "bg-[#0b1f3a] text-white"
                  : "bg-[#f6f2e9] text-[#0b1f3a]/70 hover:bg-[#efe8d8]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {current.items.map((item, i) => (
            <figure
              key={i}
              className="relative rounded-2xl border border-[#0b1f3a]/8 bg-[#f6f2e9]/40 p-8 md:p-10"
            >
              <Quote
                size={40}
                className="text-[#c2a15a]/40 mb-4"
                strokeWidth={1.5}
              />
              <blockquote className="text-[#0b1f3a]/80 text-[17px] leading-relaxed">
                {item.quote}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#0b1f3a] flex items-center justify-center text-[#c2a15a] font-display text-[16px]">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-[#0b1f3a] text-[15px]">
                    {item.name}
                  </p>
                  <p className="text-[#0b1f3a]/50 text-[13px]">{item.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
